var _g, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerve(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 19,
    viewBox: "0 0 32 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2484_7737)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2665 9.13315C12.2665 11.4158 10.416 13.2663 8.1333 13.2663C5.85052 13.2663 4 11.4158 4 9.13315C4 6.85047 5.85052 5 8.1333 5C10.416 5 12.2665 6.85047 12.2665 9.13315Z",
    fill: "#ED342B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.13292 10.9036C7.20841 8.80798 6.53054 6.85029 6.53054 6.85029H5.11328C5.11328 6.85029 5.97589 9.36299 7.57822 12.5053H8.68762C10.2899 9.36299 11.1525 6.85029 11.1525 6.85029H9.73524C9.73524 6.85029 9.05743 8.80798 8.13292 10.9036Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.9336 8.91758C25.1324 8.91758 25.0709 9.78035 25.0709 9.78035H26.7962C26.7962 9.78035 26.7347 8.91758 25.9336 8.91758ZM27.8439 10.643H25.0709C25.0709 10.643 25.1324 11.5674 26.365 11.5674C26.9811 11.5674 27.5974 11.3824 27.5974 11.3824L27.7207 12.3683C27.7207 12.3683 27.1045 12.6149 26.2417 12.6149C25.0093 12.6149 23.9001 11.9986 23.9001 10.2733C23.9001 8.91758 24.7628 8.05487 25.9953 8.05487C27.8439 8.05487 27.967 9.90352 27.8439 10.643ZM18.4148 9.18694L18.6056 8.16949C18.6056 8.16949 17.1323 7.72243 15.9348 8.55092V12.6207H17.2065V9.314C17.7152 8.93262 18.4148 9.18694 18.4148 9.18694ZM13.1137 8.91758C12.3127 8.91758 12.2511 9.78035 12.2511 9.78035H13.9764C13.9764 9.78035 13.9149 8.91758 13.1137 8.91758ZM15.0239 10.643H12.2511C12.2511 10.643 12.3127 11.5674 13.5451 11.5674C14.1611 11.5674 14.7774 11.3824 14.7774 11.3824L14.9007 12.3683C14.9007 12.3683 14.2845 12.6149 13.4217 12.6149C12.1893 12.6149 11.0801 11.9986 11.0801 10.2733C11.0801 8.91758 11.9428 8.05487 13.1753 8.05487C15.0239 8.05487 15.1471 9.90352 15.0239 10.643ZM21.5185 11.0653C20.8727 9.5153 20.5499 8.05561 20.5499 8.05561L19.2586 8.05577C19.2586 8.05577 19.9044 10.5486 21.0021 12.6142H22.0348C23.1326 10.5486 23.7784 8.05613 23.7784 8.05613H22.487C22.487 8.05613 22.1642 9.5153 21.5185 11.0653Z",
    fill: "#03435F"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 18,
    rx: 1.5,
    stroke: "#E8E8E8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2484_7737"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 9,
    fill: "white",
    transform: "translate(4 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerve);
export default __webpack_public_path__ + "static/media/verve.c1b46b63d8871715eb4c7444b49665ec.svg";
export { ForwardRef as ReactComponent };